import { useReducer, useCallback, useEffect, useRef } from 'react';
import { isCancel } from 'axios';
import { message } from 'antd';
import { instance } from 'store/utils';
import { Errors } from 'utils/errors';

/**
 * @description Handles the **Funding program details** logic (query).
 * @returns {{
 *   data: Object | null,
 *   isFetching: boolean,
 *   isError: boolean,
 *   error: unknown | null,
 * }} Query utilities.
 */
export function useFundingProgramQuery(id) {
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    if (!id) return; 

    const controller = new AbortController();

    async function searchFundingProgramDetails(id) {
      dispatch({ type: 'QUERY_START' });

      try {
        const res = await instance.get(
          `/proposal/funding-programs/search/details/${id}`,
          { signal: controller.signal }
        );
        dispatch({ type: 'QUERY_SUCCESS', payload: res.data });
      } catch (err) {
        if (isCancel(err)) {
          dispatch({ type: 'QUERY_CANCELLED' });
          return;
        }
        const errorMessage = Errors.GenericRetrievalError;
        message.error(errorMessage);
        dispatch({ type: 'QUERY_ERROR', payload: err });
      }
    }

    searchFundingProgramDetails(id);
    return () => controller.abort();
  }, [id]);

  // useEffect(() => {
  //   searchWithFilters({});

  //   return () => {
  //     if (abortControllerRef.current) {
  //       abortControllerRef.current.abort();
  //     }
  //   };
  // }, [searchWithFilters]);

  return {
    data: state.data,
    isFetching: state.isFetching,
    isError: state.isError,
    error: state.error,
  };
}

const initialState = {
  data: null,
  isFetching: false,
  isError: false,
  error: null,
};

function reducer(state, action) {
  switch (action.type) {
    case 'QUERY_START':
      return { data: null, isFetching: true, isError: false, error: null };
    case 'QUERY_SUCCESS':
      return {
        data: action.payload,
        isFetching: false,
        isError: false,
        error: null,
      };
    case 'QUERY_ERROR':
      return {
        data: null,
        isFetching: false,
        isError: true,
        error: action.payload,
      };
    case 'QUERY_CANCELLED':
      return { ...state, isFetching: false };
    default:
      return state;
  }
}